import React from "react"

const SectionTitle = ({children, textSize}) => (
    <h1 className={`${textSize || `text-2xl`} font-black text-primary`} data-sal="fade" data-sal-easing="ease" data-sal-duration="600">
        {children}
    </h1>
)

export default SectionTitle